module.exports = __webpack_public_path__ + "img/Invasion-PDAC_GSE111672.c6e3a9c4.png";